import { Component, Inject, Prop } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { ParticipacionSnp } from '@/shared/model/snp/alumno.model';
import { ParticipacionSnp as ParticipacionProfesorSnp, ProfesorAlumno } from '@/shared/model/snp/claustro.model';
import ParticipanteService from '@/components/participantes/participante.service';
import { BvTableFieldArray } from 'bootstrap-vue';

@Component
export default class AlumnoLigadoComponent extends ApeironComponent {
  @Inject('participanteService') private readonly participanteService: () => ParticipanteService;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({ required: true })
  public readonly alumno: ParticipacionSnp;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  public showLoading = false;
  public mostrarModalProfesores = false;
  public profesoresLigados: Array<ProfesorAlumno> = [];

  public readonly fieldsProfesores: BvTableFieldArray = [
    { key: 'asociado', label: this.$t('apeironGwApp.alumnoSnp.ligado.relacionActiva').toString(), class: 'text-center' },
    { key: 'alumno', label: this.$t('apeironGwApp.alumnoSnp.ligado.relacion').toString(), class: 'text-center' },
    {
      key: 'profesor.participante.cvu',
      label: this.$t('apeironGwApp.alumnoSnp.form.cvuProfesor').toString(),
      class: 'text-center',
    },
    {
      key: 'profesor',
      label: this.$t('apeironGwApp.alumnoSnp.form.nombreProfesor').toString(),
      class: 'text-center',
    },
  ];

  public mostrarModal(): void {
    this.mostrarModalProfesores = true;

    this.obtenerProfesoresLigados();
  }

  private obtenerProfesoresLigados(): void {
    this.showLoading = true;
    this.obtenerProfesores()
      .then(profesores => {
        this.profesoresLigados = [];
        profesores.forEach(profesor => {
          (profesor.profesorSnp?.alumnos ?? []).forEach(alumnoLigado => {
            if (this.alumno.participante?.cvu == alumnoLigado.cvu) {
              this.profesoresLigados.push(new ProfesorAlumno(profesor, alumnoLigado));
            }
          });
        });
      })
      .finally(() => {
        this.showLoading = false;
      });
  }

  private obtenerProfesores(): Promise<Array<ParticipacionProfesorSnp>> {
    return new Promise<Array<ParticipacionProfesorSnp>>((resolve, reject) => {
      this.participanteService()
        .obtenerProfesoresRelacionadosConAlumno(this.solicitud.id, this.alumno.participante.cvu)
        .then(res => {
          const profesores: Array<ParticipacionProfesorSnp> = [];
          (res.data ?? []).forEach(profesor => {
            profesores.push(ParticipacionProfesorSnp.fromObject(profesor));
          });
          resolve(profesores);
        })
        .catch(err => reject(Error(err)));
    });
  }
}
